import {
  type CreateTamaguiProps,
  createTamagui,
  createTokens,
  setupDev,
} from "tamagui";

import { config as defaultConfig } from "@tamagui/config/v3";
import { shorthands } from "@tamagui/shorthands";

import { animations } from "./config/animations";
import { bodyFont, fontSize, headingFont } from "./config/fonts";
import { media, mediaQueryDefaultActive } from "./config/media";
import { themes as themesIn } from "./themes/theme-generated";
import { color } from "./themes/token-colors";
import { radius } from "./themes/token-radius";
import { size } from "./themes/token-size";
import { space } from "./themes/token-space";
import { zIndex } from "./themes/token-z-index";

// Hold down Option for a second to see some helpful visuals
setupDev({
  visualizer: true,
});

/**
 * This avoids shipping themes as JS. Instead, Tamagui will hydrate them from CSS.
 */
const themes =
  process.env.TAMAGUI_OPTIMIZE_THEMES === "true"
    ? ({} as typeof themesIn)
    : themesIn;

// Extend the themes

export const config = createTamagui({
  ...defaultConfig,
  themes,
  animations,
  // We only have a "light" theme, so this is not needed.
  shouldAddPrefersColorThemes: false,
  themeClassNameOnRoot: true,
  mediaQueryDefaultActive,
  // Use the default selection styles for now - we can override this later
  // if we like, e.g.:
  // selectionStyles: theme => ({
  //   backgroundColor: theme.navy4,
  //   color: theme.gray3,
  // }),
  shorthands,
  fonts: {
    heading: headingFont,
    body: bodyFont,
  },
  tokens: createTokens({
    color,
    radius,
    zIndex,
    space,
    size,
    fontSize,
  }),
  media,
  settings: {
    //themeClassNameOnRoot: true,
    allowedStyleValues: "somewhat-strict",
    autocompleteSpecificTokens: "except-special",
    fastSchemeChange: false,
    maxDarkLightNesting: 1,
    onlyAllowShorthands: false,
  },
} satisfies CreateTamaguiProps);

export default config;
